export default "__VITE_ASSET__CT1Y60PG__"